import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdalService } from '../../service';

@Component({
	selector: 'app-sidebar-nav',
	templateUrl: 'sidebar-nav.component.html',
	styleUrls: ['sidebar.style.css']
})
export class SideBarComponent implements OnInit {
	toggle = false;
	showMasterData = false;
	showProductMasterManagement = false;
	showGeneralDataManagement = false;
	showSecurity = false;
	showSourceData = false;
	showSalonRelatedMapping = false;
	showProductRelatedMapping = false;
	activeItem: string = '';

	menuItems = [
		{
			text: 'Dashboard',
			path: '/utility/dashboard',
			disabled: false
		},
		{
			text: 'Master Data',
			items: [
				{ text: 'Salon Master Management', path: '/utility/salon-master-management', disabled: true },
				{ text: 'Product Master Management', items: [
						{ text: 'Product Barcode Assignment', path: '/utility/product-barcode-assignment', disabled: false }
					], disabled: false },
				{ text: 'Service Master Management', path: '/utility/service-master-management', disabled: true },
				{ text: 'General Data Management', items: [
						{ text: 'Quarter Master', path: '/utility/quarter-master-mapping', disabled: false }
					], disabled: false }
			],
			disabled: false
		},
		{
			text: 'Source Data',
			items: [
				{ text: 'Source Data Management', path: '/utility/source-data-management', disabled: true },
				{ text: 'Salon Related Mapping', items: [
						{ text: 'Country Mapping', path: '/utility/country-mapping', disabled: false },
						{ text: 'Country Subdivision Mapping', path: '/utility/country-subdivision-mapping', disabled: false },
						{ text: 'Postal Code Mapping', path: '/utility/postal-code-mapping', disabled: false },
						{ text: 'Salon Type Mapping', path: '/utility/salon-type-mapping', disabled: false },
						{ text: 'Salon Chain Mapping', path: '/utility/salon-chain-mapping', disabled: false },
						{ text: 'Salon Mapping', path: '/utility/salon-mapping', disabled: false }
					], disabled: false },
				{ text: 'Product Related Mapping', items: [
						{ text: 'Category Mapping', path: '/utility/category-mapping', disabled: false },
						{ text: 'Company Mapping', path: '/utility/company-mapping', disabled: false },
						{ text: 'Product Mapping', path: '/utility/product-mapping', disabled: false },
						{ text: 'Barcode Prefix Mapping', path: '/utility/barcode-prefix-mapping', disabled: true },
					{ text: 'Barcode Mapping', path: '/utility/product-to-barcode-mapping', disabled: false }
					], disabled: false },
				{ text: 'Service Related Mapping', path: '/utility/service-mapping', disabled: false }
			],
			disabled: false
		},
		{
			text: 'Security',
			items: [
				{ text: 'User Management', path: '/utility/user-management', disabled: false }
			],
			disabled: false
		},
		{
			text: 'Reports',
			path: '/utility/processed-salon-counts',
			disabled: false
		}
	];

	constructor(private adalService: AdalService, private router: Router) {}

	setActiveItem(item: string) {
		this.activeItem = item;
	}

	logout() {
		this.adalService.logout();
		this.router.navigate(['logout']);
	}

	onItemClick(event: any) {
		const item = event.itemData;
		if (item.path) {
			this.router.navigate([item.path]);
		}
	}

	ngOnInit() {}
}
